import React, {useEffect, useState} from 'react';
import {Specialist, Complaince, About, Stats, Explanation, Hero, Footer, Contact, UploadModal} from '@/components';
import {resetPersistData} from '@/services/redux/slices/authSlice';
import {useDispatch} from 'react-redux';
import {clearPreSignupFilesToken} from '@/utils/common_functions';
import {Helmet} from 'react-helmet-async';
import {API} from '@/constants/api';
import { HOME_PAGE_META } from '@/constants/defaults';

export const LandingScreen: React.FC = () => {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  function openModal() {
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }

  useEffect(() => {
    // only dispatching persisted formdata to reset the form data
    dispatch(resetPersistData());

    // clear the pre-signup files
    clearPreSignupFilesToken();
  }, [dispatch]);
  return (
    <>
      <HomePageMeta />
      <div className="flex flex-col grow overflow-x-hidden w-full">
        <Hero openModal={openModal} id="home" />
        <Explanation openModal={openModal} id="service" />
        <Stats id="stats" />
        <Complaince id="complaince" />
        <Specialist id="doctor" />
        <About id="about" />
        <Contact id="contact" />
        <Footer />

        <UploadModal open={modalOpen} onClose={closeModal} />
      </div>
    </>
  );
};

function HomePageMeta() {
  const REACT_APP_URL = API.currentEnv ? API.webAppUrls[API.currentEnv as keyof typeof API.baseUrls] : API.baseUrls.dev;
  return (
    <Helmet>
      <title>{HOME_PAGE_META.base.title}</title>

      <meta
        name="description"
        content={HOME_PAGE_META.base.description}
      />

      <meta
        name="keywords"
        content={HOME_PAGE_META.base.keywords.join(', ')}
      />

      <meta name="robots" content="index, follow" />

      <link rel="canonical" href={REACT_APP_URL} />

      <meta property="og:title" content={HOME_PAGE_META.og.title} />
      <meta property="og:description" content={HOME_PAGE_META.og.description} />
      <meta property="og:type" content={HOME_PAGE_META.og.type} />
      <meta property="og:url" content={REACT_APP_URL} />
      <meta property="og:image" content={`${REACT_APP_URL}/images/og-image.png`} />
      <meta property="og:image:width" content="117" />
      <meta property="og:image:height" content="117" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={HOME_PAGE_META.twitter.title} />
      <meta name="twitter:description" content={HOME_PAGE_META.twitter.description} />
      <meta name="twitter:image" content={`${REACT_APP_URL}/images/og-image.png`} />
      <meta name="twitter:image:width" content="117" />
      <meta name="twitter:image:height" content="117" />
    </Helmet>
  );
}
